import { create } from 'zustand';

interface BrandingState {
  logo: string | null;
  mainColor: string | null;
  secondaryColor: string | null;
  bgColor: string | null;
  loaded: boolean;
  setBranding: (b: {
    logo: string;
    mainColor: string;
    secondaryColor: string;
    bgColor: string;
  }) => void;
}

export const useBrandingStore = create<BrandingState>()((set) => ({
  logo: null,
  mainColor: null,
  secondaryColor: null,
  bgColor: null,
  loaded: false,
  setBranding: ({ logo, mainColor, secondaryColor, bgColor }) =>
    set({ logo, mainColor, secondaryColor, bgColor, loaded: true }),
}));
